import { useEffect, useState } from 'react'
import { useAccountContext, useAppContext } from '../contexts'
import { DeviceListController } from '../components/DeviceListController'
import { Drawer } from '../components/Drawer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { useWindowDimensions } from '../hooks/useWindowDimensions'
import { isPhone } from '../common/constants'

const MIN_WIDTH = 350
// const MIN_HEIGHT = 500

interface Props {
  children: React.ReactNode
}

export function Layout({ children }: Props) {
  const { width, height } = useWindowDimensions()

  const { showDeviceListDrawer, setShowDeviceListDrawer } = useAppContext()
  const { selectDevice } = useAccountContext()

  const [rightAreaWidth, setRightAreaWidth] = useState(MIN_WIDTH)
  const [rightAreaHeight, setRightAreaHeight] = useState(MIN_WIDTH)

  const isMobilePortraitMode = isPhone && width < height

  useEffect(() => {
    !isPhone && selectDevice('')
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isPhone) {
      if (isMobilePortraitMode) {
        setRightAreaWidth(width - 23)
        setRightAreaHeight(height - 30)
      } else {
        setRightAreaWidth(width - 60)
        setRightAreaHeight(height - 20)
      }
    } else {
      setRightAreaWidth(width - 250)
      setRightAreaHeight(height - 20)
    }
  }, [width, height]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className={`flex flex-row ml-2.5 ${isPhone ? 'pt-1' : 'pt-3'}`}>
        {!isPhone && (
          <div className="flex flex-col -z-100">
            <DeviceListController />
          </div>
        )}

        <div
          id="primary-content"
          className={`flex flex-col ${isPhone && !isMobilePortraitMode && 'ml-6'}`}
          style={{ width: `${rightAreaWidth}px`, height: `${rightAreaHeight}px` }}
        >
          {children}
        </div>
      </div>

      {isPhone && (
        <>
          {showDeviceListDrawer && (
            <div className="absolute top-0 left-0 z-100">
              <Drawer open={showDeviceListDrawer} side="left">
                <DeviceListController />
              </Drawer>
            </div>
          )}
        </>
      )}

      {isPhone && (
        <div>
          <div className={`absolute bottom-0 left-0 p-2 bg-gray-300 z-1000`}>
            {showDeviceListDrawer ? (
              <FontAwesomeIcon icon={faChevronLeft} size="lg" onClick={() => setShowDeviceListDrawer(false)} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} size="lg" onClick={() => setShowDeviceListDrawer(true)} />
            )}
          </div>
        </div>
      )}

      <div className="fixed bottom-1 left-2 text-xs text-gray-400 select-none pointer-events-none">
        {process.env.REACT_APP_GIT_COMMIT}
      </div>
    </div>
  )
}
